import styled, { css } from 'styled-components';
import type { RouterLinkProps } from '@redux-first-router-link';
import { RouterLink } from '@redux-first-router-link';
import { Row } from '@simplywallst/ui-core';

type StyleType = 'light' | 'dark';

interface StyleProps {
  styleType?: StyleType;
}

interface PageProps extends StyleProps {
  disabled: boolean;
}

interface PageLinkProps extends RouterLinkProps {
  styleType?: StyleType;
}

const PrevNext = css<PageProps>`
  ${({ theme }) => theme.typography.xSmall};
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  text-decoration: none;
  display: flex;
  align-items: center;
  svg {
    ${({ disabled, theme }) => disabled && `width: ${theme.x6spacePx}px`};
    * {
      fill: ${({ theme, disabled, styleType }) =>
        styleType === 'light'
          ? theme.color.spaceGrayRGBA(disabled ? 0.3 : 1)
          : theme.color.whiteRGBA(disabled ? 0.3 : 1)};
    }
  }
`;

export const PrevPages = styled('div')<PageProps>`
  ${PrevNext}
`;

export const NextPages = styled('div')<PageProps>`
  ${PrevNext}
  svg {
    transform: rotate(180deg);
  }
`;

export const PageLink = styled(RouterLink)<PageLinkProps>`
  background: transparent;
  height: ${({ theme }) => theme.x6spacePx}px;
  width: ${({ theme }) => theme.x6spacePx}px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.x6spacePx}px;
  &:hover {
    background: ${({ theme, styleType }) =>
      styleType === 'light'
        ? theme.color.spaceGrayRGBA(0.1)
        : theme.color.whiteRGBA(0.1)};
  }
`;

export const PaginationRow = styled(Row)`
  min-height: 48px;
`;

export const PageCount = styled('div')<PageLinkProps>`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.typography.xSmall};
  color: ${({ theme, styleType }) =>
    styleType === 'light' ? theme.color.spaceGray : theme.color.white};
`;

export const PaginationWrapper = styled('div')<StyleProps>`
  padding: ${({ theme }) => `${theme.x1spacePx}px 0`};
  border-top: 1px solid
    ${({ theme, styleType }) =>
      styleType === 'light'
        ? theme.color.spaceGrayRGBA(0.1)
        : theme.color.whiteRGBA(0.1)};
  border-bottom: 1px solid
    ${({ theme, styleType }) =>
      styleType === 'light'
        ? theme.color.spaceGrayRGBA(0.1)
        : theme.color.whiteRGBA(0.1)};
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
`;
